<template lang="pug">
span
  span(@click="handleClick")
    slot(name="activator")
  v-dialog.d-inline(v-model="isModalVisible" persistent max-width="480")
    v-card(data-cy="tag-modal")
      title-bar(dark) {{ getTitle }}
      v-card-text
        span(v-if="action !== 'add'") {{ bodyText }}
        tags-picker(
          v-if="action !== 'delete'"
          v-model="selectedTags"
          :disabled="false"
          :tags-list="tagsList"
          :label="getTagsPickerLabel"
          :icon="getTagsPickerIcon"
          @update:searchInput="findTags"
          @save:tag="createTag"
        )
      v-card-actions
        v-spacer
        v-btn(flat @click="cancel") Cancel
        v-btn.primary(@click="save" data-cy="save-tag-btn") {{ getButtonLabel }}
</template>

<script>
import { mapActions } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';
import Modal from '@/Core/mixins/modal';
import TagsPicker from '@/Core/components/TagsPicker';
import { createTagsString } from '../../utilities';

export default {
components: {
    TitleBar,
    TagsPicker,
  },
  mixins: [Modal],
  props: {
    action: {
      type: String,
      default: 'add',
      validator: value => ['add', 'remove', 'replace', 'delete'].includes(value),
    },
    tagsList: { 
      type: Array,
    },
    selectedIds: {
      type: Array,
    },
    patchContacts: {
      type: Function,
    },
    contactUpdateActionPayload: {
      type: Function,
    },
    totalContactsSelected: {
      type: Number,
    },
  },
  data() {
    return {
      selectedTags: [],
    };
  },
  computed: {
    getTitle() {
      const totalContacts = this.totalContactsSelected || this.selectedIds.length;
      const contactWord = totalContacts > 1 ? 'contacts' : 'contact';
      const title = `tags for ${totalContacts} ${contactWord}`
      
      switch (this.action) {
        case 'add':
          return `Add ${title}`;
        case 'remove':
          return `Remove ${title}`;
        case 'replace':
          return `Replace ${title}`;
        case 'delete':
          return `Delete all ${title}`;
      }
    },
    getButtonLabel() {
      switch (this.action) {
        case 'add':
          return `Save`;
        case 'remove':
          return `Remove`;
        case 'replace':
          return `Replace`;
        case 'delete':
          return `Delete`;
      }
    },
    bodyText() {
      switch (this.action) {
        case 'remove':
          return `You will remove selected tags from contacts.`;
        case 'replace':
          return `You will replace all tags with the new ones selected.`;
        case 'delete':
          return `You will delete all the tags from your selected contacts.`;
      }
    },
    getTagsPickerLabel() {
      switch (this.action) {
        case 'remove':
          return `Remove Tags`;
        case 'replace':
          return `Replace Tags`;
      }
    },
    getTagsPickerIcon() {
      switch (this.action) {
        case 'remove':
          return `$vuetify.icons.tag-minus`;
        case 'replace':
          return `$vuetify.icons.tag-right-arrow`;
      }
    },
  },
  methods: {
    ...mapActions('contact', ['findTags', 'createTag']),
    async handleClick() {
      await this.findTags();
      this.modal_open();
    },
    async save() {
      const action = this.contactUpdateActionPayload({
          tags: createTagsString(this.selectedTags),
          action: this.action,
        });

      const payload = {
        action,
        selected: this.selectedIds,
      };
      this.modal_close();
      await this.patchContacts(payload);
      this.$emit('deselect-all');
      this.$emit('contact-updated');
      this.cancel();
    },
    cancel() {
      this.modal_close();
      this.selectedTags = [];
    },
  },
}
</script>
